export default {
  SET_TAGS(state, payload) {
    state.tagsDetails = payload;
  },
  SET_AllTAGS(state, payload) {
    state.allTags = payload;
  },
};
